import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { unsetAuth } from "../../helpers/authHelper";
import './scss/NavBar.scss';
import useAuthServices from "../../hooks/useAuthService";
import { IconLogout } from "@tabler/icons-react";

const OptionDev = () => {
  
  const { handleLogout } = useAuthServices()

  return (
    <nav className="dropdown-menu bg-white absolute mt-[45px] lg:shadow-lg lg:rounded-[5px] w-fit right-[15px] z-[100] px-4">
      <ul className="w-max">
        <li className="w-fit">
          <ul className="w-fit">
            <li onClick={handleLogout}
              className="hover:bg-green200 hover:text-green700  text-sm lg:text-base py-2 lg:pl-2 lg:pr-6 rounded-b-lg">
              <button className="flex justify-between items-center gap-2 text-sm text-[#212121] font-medium">
                <IconLogout /> Cerrar sesión
                </button>
            </li>
          </ul>
        </li>
      </ul>
    </nav>
  );
};

export default OptionDev;
